// src/config.js
const AppConfig = {
    title: "تازەترین وتاری مامۆستا کرێکار ناسراو بە شێخی زیندان",
    paragraph: "مامۆستا کرێکار",
    img: "https://i.postimg.cc/qvdj6bTs/f8b7f018-ce5b-4854-9bb5-deadc1f908f8.jpg",
    url: "mamostakrekar",
    id: "3290326"
};

export default AppConfig;